import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import Stack from '@mui/material/Stack'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'

import ConsultationsTable from '../components/ConsultationsTable'

import NoResults from '@/assets/svg/no-results.svg?react'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import {
  getConsultations,
  selectConsultations,
  selectConsultationSearchParams,
  selectConsultationSearchResult,
} from '@/redux/reducers/consultation.reducer'
import { isStaff } from '@/utils/type-guards'

export const limitOptions = [5, 10, 15]

export function ConsultationsTableContainer() {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const authUser = useAppSelector(selectAuthUser)
  const consultations = useAppSelector(selectConsultations)
  const consultationSearchParams = useAppSelector(selectConsultationSearchParams)
  const consultationSearchResult = useAppSelector(selectConsultationSearchResult)

  const handleChangePage = (page: number) => {
    const limit = _.get(consultationSearchParams, 'options.limit', limitOptions[0])
    const query = _.get(consultationSearchParams, 'query', {})
    dispatch(getConsultations(query, { limit, skip: (page - 1) * limit, order: 'ASC', orderBy: 'startDate' }))
  }

  const handleChangeRowsPerPage = (rowsPerPage: number) => {
    const query = _.get(consultationSearchParams, 'query', {})
    dispatch(getConsultations(query, { limit: rowsPerPage, order: 'ASC', orderBy: 'startDate' }))
  }

  return !consultations.length ? (
    <Stack direction="column" justifyContent="center" alignItems="center">
      <CardMedia component={NoResults} sx={{ width: 'auto', height: '250px', mt: '10px', mr: '40px' }} />
      <Typography component="div" variant="body1">
        {t('page.consultations.noConsultationMessage')}
      </Typography>
    </Stack>
  ) : (
    <ConsultationsTable
      data={consultations}
      isDoctor={isStaff(authUser) && authUser?.status === 'MEDECIN'}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      rowsPerPageOptions={limitOptions}
      totalCount={_.get(consultationSearchResult, 'totalCount', 0)}
    />
  )
}

export default ConsultationsTableContainer
